// Flint & Fin grid view (sections/ff-grid-view.liquid): "Product / In a room" and frame swatches for collection grids.
// Each card's alternate images come from data-ff-views on its .card-gallery (snippets/ff-card-views.liquid).
// The choice lives in localStorage (a per-device convenience; the page works the same without it).
(() => {
  const KEY = 'ff-grid-view';
  const root = document.querySelector('[data-ff-grid-view]');
  if (!root) return;

  let state = { view: 'product', frame: null };
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && (saved.view === 'product' || saved.view === 'room')) state = { view: saved.view, frame: saved.frame || null };
  } catch (e) {}

  const save = () => {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  };

  const viewsOf = (gallery) => {
    if (!gallery._ffViews) {
      try { gallery._ffViews = JSON.parse(gallery.dataset.ffViews); } catch (e) { gallery._ffViews = {}; }
    }
    return gallery._ffViews;
  };

  const applyCard = (gallery) => {
    const host = gallery.querySelector('slideshow-component, .product-media-container');
    if (!host) return;
    let img = host.querySelector(':scope > .ff-view-img');
    // default cards: unframed first, maple frame on hover
    if (state.view === 'product' && !state.frame) {
      if (img) img.hidden = true;
      return;
    }
    const frame = state.frame || 'maple';
    const views = viewsOf(gallery);
    const entry = views[`${state.view}-${frame}`] || views[`${state.view}-maple`];
    if (!entry) {
      if (img) img.hidden = true;
      return;
    }
    if (!img) {
      img = document.createElement('img');
      img.className = 'ff-view-img';
      img.alt = '';
      img.decoding = 'async';
      img.sizes = '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw';
      host.classList.add('ff-view-host');
      host.appendChild(img);
    }
    if (img.getAttribute('src') !== entry.src) {
      img.srcset = entry.srcset;
      img.src = entry.src;
    }
    img.style.objectFit = entry.fit || 'cover';
    img.classList.toggle('ff-view-img--room', state.view === 'room');
    img.hidden = false;
  };

  const applyAll = () => {
    for (const b of root.querySelectorAll('[data-ff-view]')) b.setAttribute('aria-pressed', String(b.dataset.ffView === state.view));
    const shown = state.frame || (state.view === 'room' ? 'maple' : null);
    for (const b of root.querySelectorAll('[data-ff-frame]')) b.setAttribute('aria-pressed', String(b.dataset.ffFrame === shown));
    document.querySelectorAll('.card-gallery[data-ff-views]').forEach(applyCard);
  };

  root.addEventListener('click', (event) => {
    const view = event.target.closest('[data-ff-view]');
    const frame = event.target.closest('[data-ff-frame]');
    if (view) state.view = view.dataset.ffView;
    if (frame) {
      const key = frame.dataset.ffFrame;
      // tapping the chosen frame again in product view goes back to the default cards
      state.frame = state.frame === key && state.view === 'product' ? null : key;
    }
    if (view || frame) {
      save();
      applyAll();
    }
  });

  // filters, sorting and paging replace the grid without a page load: re-apply to new cards
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      applyAll();
    });
  }).observe(document.body, { childList: true, subtree: true });

  applyAll();
})();
